import React from 'react';
import { motion } from 'framer-motion';
import { Layers, ArrowRight } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide07Scope({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-124">
      <SlideHeader eyebrow="What Is a Trailer / Microsite?" data-id="element-125">
        The trailer is the deeper campaign experience
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-126">
        <div className="flex-1 space-y-8" data-id="element-127">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-128">
            A trailer works like a compact interactive microsite. It covers the
            most important campaign issue in a guided, engaging format and can
            be adapted to each monthly campaign focus.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="grid grid-cols-2 gap-4" data-id="element-129">
            {['Campaign topic introduction', 'Educational content from approved assets', 'HCP choice paths', 'Key message reinforcement', 'Peer comparison', 'Final CTA'].map((module, i) => <div key={i} className="bg-[var(--surface)] p-4 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-130">
                <Layers className="h-5 w-5 text-[var(--brand)] flex-shrink-0 mt-0.5" data-id="element-131" />
                <span className="text-sm font-semibold text-[var(--fg)]" data-id="element-132">
                  {module}
                </span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="inline-flex items-center gap-3 bg-white border border-black/10 px-5 py-3 rounded-full shadow-sm" data-id="element-133">
            <span className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-134">
              Typical Length:
            </span>
            <span className="bg-[var(--brand)] text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-135">
              2–3 minutes
            </span>
          </motion.div>
        </div>

        {/* Microsite Flow Map */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-1 w-full bg-[var(--surface)] rounded-3xl p-8 border border-black/5 flex items-center justify-center" data-id="element-136">
          <div className="w-full flex items-center justify-center" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/p6ppG5pnhmcycdnfkHwqSz/Screenshot_2026-06-29_at_13.11.56.png" alt="Trailer / Microsite flow example" className="w-full h-auto rounded-2xl shadow-md border border-black/10" data-id="element-138" />
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}